const DECIMAL_STRING_PATTERN = /^-?\d+(\.\d+)?$/;

/** Converts locale decimal input (comma) to API decimal string (dot). */
export const normalizeDecimalStringForApi = (value: string): string =>
  value.trim().replace(",", ".");

export const isValidDecimalStringInput = (value: string): boolean => {
  const normalized = normalizeDecimalStringForApi(value);
  if (!DECIMAL_STRING_PATTERN.test(normalized)) {
    return false;
  }
  return Number.isFinite(Number(normalized));
};

export const normalizeDecimalStringForApiOrNull = (
  value: string | null | undefined,
): string | null => {
  if (value == null) {
    return null;
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }
  return normalizeDecimalStringForApi(trimmed);
};

/** Normalizes selected keys in a plain object before sending to the API. */
export const normalizeDecimalStringFields = <T extends Record<string, unknown>>(
  payload: T,
  fieldKeys: readonly (keyof T)[],
): T => {
  const normalized = { ...payload };
  for (const key of fieldKeys) {
    const value = normalized[key];
    if (typeof value === "string" && value.trim() !== "") {
      normalized[key] = normalizeDecimalStringForApi(value) as T[keyof T];
    }
  }
  return normalized;
};
